import { LoadingWrapper } from "@vapor/react-contrib-tax-compliance";
import { Stack } from "@vapor/react-material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();

interface PdfPreviewerProps {
    file: Uint8Array;
}

export const PdfPreviewer = ({ file }: PdfPreviewerProps) => {
    const { t } = useTranslation();

    const pdf = useMemo(() => ({ data: new Uint8Array(file) }), [file]);

    return (
        <Stack justifyContent="center" alignItems="center">
            <Document
                file={pdf}
                onLoadError={(error) => {
                    console.error("Error loading PDF document:", error);
                }}
                loading={
                    <LoadingWrapper
                        loading={true}
                        spinnerProps={{
                            loadingText: t(
                                "components.loading_wrapper.loading_message",
                            ),
                        }}
                    />
                }
            >
                {({ pdf }) =>
                    Array.from({ length: pdf.numPages }, (_el, index) => (
                        <Page
                            key={index}
                            pageIndex={index}
                            loading={
                                <LoadingWrapper
                                    loading={true}
                                    spinnerProps={{
                                        loadingText: t(
                                            "components.loading_wrapper.loading_message",
                                        ),
                                    }}
                                />
                            }
                            width={800}
                        />
                    ))
                }
            </Document>
        </Stack>
    );
};
